import React from 'react';
import { connect } from 'react-redux';
import DsModal from '../../../ds/molecules/DsModal';
import IframeComponent from '../IframeVideo360';
import RoomDetail from './RoomDetail';
import DoubleSlider from '../DoubleSlider';
import { getLangValue } from '../../../../utils/Generic';
import { DEVICES } from '../../../../actions/Booking';

const content = (modalContent, room) => {
  switch (modalContent) {
    case 'room-360':
      return <IframeComponent src={room.url_360} className="w-full h-full"/>;
    case 'room-video':
      return <IframeComponent src={room.url_youtube} className="w-full h-full"/>;
    case 'description':
    default:
      return <RoomDetail room={room} />;
  }
};

const RoomModal = ({
  onClose, room, modalContent, isMobile, lang,
}) => {
  if (modalContent === 'gallery') {
    return <DoubleSlider
      photos={room.photos}
      onClose={onClose}
      imageSize={isMobile ? 'sm' : 'xl'}
      room={room}
      roomName={getLangValue(room, lang, 'name')}
    />;
  }

  if (modalContent === 'floor-plan') {
    return <DoubleSlider
            photos={room.floor_plan}
            onClose={onClose}
            imageSize={isMobile ? 'sm' : 'xl'}
            room={room}
            roomName={getLangValue(room, lang, 'name')}
    />;
  }

  const showFullScreen = ['room-360', 'room-video'].includes(modalContent);
  return (
    <DsModal onClose={onClose} fullScreen={showFullScreen}>
      {content(modalContent, room, isMobile, lang, onClose)}
    </DsModal>

  );
};

export default connect((state) => ({
  isMobile: state.booking.device === DEVICES.MOBILE,
  lang: state.i18nState.lang,
}))(RoomModal);
